function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRustoreIcon = function SvgRustoreIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    fill: "none",
    stroke: "#FFF",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 4.6249,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.853 24.746v-4.319c0-2.762 2.611-4.789 5.304-4.116l17.054 4.26a5.31 5.31 0 0 1 4.034 5.146v28.658c0 2.763-2.611 4.789-5.304 4.116l-10.09-2.52",
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 4.6249,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(2.5351 0 0 2.6556 -15.545 -20.844)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.805 31.18v-4.154c0-2.763 2.61-4.79 5.304-4.117l17.053 4.26a5.31 5.31 0 0 1 4.034 5.146v28.658c0 2.763-2.61 4.79-5.304 4.116L41.76 62.558",
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 4.6249,
      strokeLinecap: "square",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(2.5351 0 0 2.6556 -15.545 -20.844)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.79 67.427a5.31 5.31 0 0 1-4.034-5.146V33.623c0-2.763 2.61-4.789 5.304-4.116l17.054 4.26a5.31 5.31 0 0 1 4.033 5.146V67.57c0 2.762-2.61 4.789-5.304 4.116z",
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 4.6249,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(2.5351 0 0 2.6556 -15.545 -20.844)"
  })));
};
export default SvgRustoreIcon;